import { createGlobalStyle } from 'styled-components';

const StepTwoStyles = createGlobalStyle`
  .step2-page {
    background: #f6f6f6;
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  .step2-page .container-md {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .step2-page .step2-container {
    background: #f6f6f6;
    padding: 0px 20px 20px;
    position: relative;
    flex: 1;
  }

  .step2-page .step2-container .left {
    padding-bottom: 74px;
  }

  .step2-page .step2-container .left p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #6f7072;
    margin-top: 32px;
  }

  .step2-page .step2-container .right {
    display: none;
  }
  
  .step2-page .step2-container .captured-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0px;
    gap: 24px;
    width: 100%;
    padding-top: 96px;
  }

  .step2-page .step2-container .captured-list .captured-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 10px;
    border: 1px dashed #a0a0a0;
    border-radius: 12px;
    position: relative;
    aspect-ratio: 7/4;
    width: 100%;
  }

  .step2-page .step2-container .captured-list .captured-item.read-only {
    border: none;
  }

  .step2-page .step2-container .captured-list .captured-item.successful {
    border: 1px dashed #00d764;
  }

  .step2-page
    .step2-container
    .captured-list
    .captured-item.successful
    .icon-checked {
    display: flex;
  }

  .step2-page .step2-container .captured-list .captured-item > img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    border-radius: 12px;
    overflow: hidden;
    object-fit: cover;

    &.gks, &.passport {
      height: auto;
    }
  }

  .step2-page .step2-container .captured-list .captured-item > img[src=""] {
    display: none;
  }

  .step2-page
    .step2-container
    .captured-list
    .captured-item
    > img:not([src=""])
    ~ .capture-item-placeholder {
    opacity: 0;
  }

  .step2-page
    .step2-container
    .captured-list
    .captured-item
    .capture-item-placeholder {
    padding: 24px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #ffffff;
    justify-content: center;
  }

  .step2-page
    .step2-container
    .captured-list
    .captured-item
    .capture-item-placeholder
    svg
    path {
    fill: #ffffff;
  }

  .step2-page .step2-container .captured-list .captured-item .icon-checked {
    border-radius: 50%;
    background-color: #ffffff;
    position: absolute;
    right: -12px;
    top: -12px;
    z-index: 2;
    display: none;
    align-items: center;
    justify-content: center;
  }

  .step2-page .step2-container > p {
    margin-top: 32px;
    margin-bottom: 24px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #6f7072;
  }

  .group-fields {
    display: flex;
    width: 100%;
    gap: 10px;
  }

  .group-fields .form-field {
    flex: 1;
  }

  .step2-page .step2-container .btns-section {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    left: 0px;
    bottom: 20px;
    width: 100%;
  }
  .step2-page .step2-container .btns-section button a {
    display: block;
    width: 100%;
    height: 100%;
  }

  .step2-page .step2-container .btns-section button a:hover,
  .step2-page .step2-container .btns-section button a:active:focus{
    text-decoration: none;
  }

  .step2-page .step2-container .form-field.active .genic-down::before {
    content: "\e949";
    font-size: 10px;
    color: #c21b17;
  }

  @media screen and (min-width: 576px) {
    .step2-page .step2-container {
      display: flex;
      gap: 24px;
      padding: 0px 20px 20px;
    }
    .step2-page .step2-container .left {
      flex: 1;
    }

    .step2-page .step2-container .right {
      flex: 1;
      display: flex;
    }

    .step2-page .step2-container .captured-list {
      padding-top: 72px;
    }

    .step2-page
      .step2-container
      .captured-list
      .captured-item
      .capture-item-placeholder {
      color: #c21b17;
    }
    .step2-page
      .step2-container
      .captured-list
      .captured-item
      .capture-item-placeholder
      svg
      path {
      fill: #c21b17;
    }

    .step2-page form .group-fields {
      flex-direction: column;
      gap: 0;
    }
    .step2-page form .btns-section {
      padding: 0px 20px;
    }
    .step2-page form .btns-section button {
      flex: 1;
    }
  }
  @media screen and (min-width: 769px) {
    .step2-page .step2-container {
      display: flex;
      gap: 24px;
      padding: 0px 0px 20px;
    }

    .step2-page .step2-container .left {
      flex: 6.64;
      padding-bottom: 0;
    }

    .step2-page .step2-container .right {
      flex: 3.33;
      display: flex;
    }

    .step2-page .step2-container .left p {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      text-align: left;
      color: #6f7072;
      margin-bottom: 32px;
    }

    .step2-page .step2-container .left form .btns-section {
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      margin-top: 30px;
      padding: 0;
    }

    .step2-page .step2-container .left form .btns-section > button {
      flex: 1;
    }

    .step2-page .step2-container .left form .btns-section button.btn-secondary {
      border-color: #cccccc;
    }

    .step2-page form .group-fields {
      flex-direction: row;
      gap: 12px;
    }
    .step2-page .step2-container .captured-list {
      padding-top: 96px;
    }
  }

  @media screen and (max-width: 768px) {
    .container-fluid {
      max-width: 100%;
      padding: 0px;
    }
  }

  @media screen and (max-width: 576px) {
    .step2-page .step2-container .right {
      position: relative;
      display: flex;
      bottom: 74px;
      left: 0;
      width: 100%; 

      .captured-list {
        padding-top: 0px;
      }
    }
    
    .step3-page .container-fluid .main-content .live-camera .camera-wp .background-camera {
      top: -26px;
    }

    .step2-page .step2-container .captured-list .captured-item > img {
      &.gks, &.passport {
        object-fit: contain;
        height: 100%
      }
    }
  }

  @media screen and (max-width: 320px) {
    .step2-page form .group-fields {
      flex-direction: column;
      gap: 10;
    }
    .step2-page .step2-container .btns-section {
      width: 100%;
      padding: 0px 20px;
    }
    .step2-page .step2-container .btns-section button {
      padding: 12px 20px;
    }
  }

  
  /* Start::APP-240215 eKYC Enhancement 2024 | GVL01767 2024-06-26 */
  body .confirm-liveness-popup .title-wp {
    color: #20252b;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 133.333% */
  }

  body .confirm-liveness-popup .content-wp {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0px 22px;
    margin-top: 24px;
  }

  body .content-wp .img-wp {
    display: flex;
    width: 335px;
    height: 335px;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background: #d8d8d8;
    overflow: hidden;
    margin: auto;
  }

  .img-wp img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-image: url("/images/icons/image-file.svg");
    background-repeat: no-repeat;
    background-position: center;
    border: none;
  }

  body .content-wp .message-wp {
    color: #20252b;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .footer-wp {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 20px 0px 0px;
    padding: 0px 22px;
    box-shadow: none;
  }

  .footer-wp .warning {
    display: flex;
    padding: 8px 12px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 6px;
    background: #ff7500;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1 0 0;
    color: #fff;
  }

  .footer-wp .footer-wp-message {
    text-align: justify;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 15px; /* 125% */
    letter-spacing: 0.12px;
  }

  .footer-wp .footer-wp-message span {
    font-feature-settings: "clig" off, "liga" off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: 0.12px;
  }

  .footer-wp
    .actions {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
  }

  .footer-wp
    .actions
    .btn {
    flex: 1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    color: #5e6671;
    /* Body/B3 Grey on dark 1440 */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    max-width: unset;
  }

  .footer-wp
    .actions
    .btn
    .icon {
    width: 24px;
    height: 24px;
  }

  .footer-wp
    .actions
    .btn.btn-primary {
    color: #fff;
    background: #c21b17;
  }

  /* End::APP-240215 eKYC Enhancement 2024 | GVL01767 2024-06-26 */
`;

export default StepTwoStyles;
